import React from 'react';
import { LucideProps, RefreshCwIcon } from 'lucide-react';
import { cn } from '../utils';

export const Loading = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ className, ...props }, ref) => (
    <RefreshCwIcon
      ref={ref}
      className={cn('size-4 min-w-4 animate-spin', className)}
      {...props}
    />
  )
);
